import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  ExcelDownloadConfig,
  ExcelSheetConfig,
} from './excel-workbook.model';

@Injectable({ providedIn: 'root' })
export class ExcelService {
  download(config: ExcelDownloadConfig): void {
    const wb = XLSX.utils.book_new();
    for (const sheet of config.sheets) {
      XLSX.utils.book_append_sheet(wb, this.buildSheet(sheet), sheet.sheetName);
    }
    const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, config.fileName);
  }

  private buildSheet(sheet: ExcelSheetConfig): XLSX.WorkSheet {
    const colCount = sheet.columns.length;
    const filler = Array(Math.max(colCount - 2, 0)).fill('');

    const headerBlockRows = (sheet.headerBlock ?? []).map((e) => [
      e.label,
      e.value,
      ...filler,
    ]);

    const hasHeaderBlock = headerBlockRows.length > 0;
    const columnHeaderRow = sheet.columns.map((c) => c.header);

    const wsData: (string | number | null | undefined)[][] = [
      ...headerBlockRows,
      ...(hasHeaderBlock ? [[]] : []), 
      columnHeaderRow,
      ...sheet.rows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws['!cols'] = sheet.columns.map((c) => ({ wch: c.width }));

    if (hasHeaderBlock && colCount > 2) {
      ws['!merges'] = headerBlockRows.map((_, i) => ({
        s: { r: i, c: 1 },
        e: { r: i, c: colCount - 1 },
      }));
    }

    return ws;
  }
}
